import { Button, Flex, Text } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { useFormState } from 'react-hook-form';
import { TextInput } from '@lon/mathnation-suit/components';
import { Icon } from '@lon/shared/components';

const MFAForm: FC<{ onCancel(): void }> = ({ onCancel }) => {
  const { isSubmitting } = useFormState();
  const [isPreview, setPreview] = useState(true);

  if (isPreview) {
    return (
      <>
        <Flex
          justifyContent="center"
          flexDir="column"
          alignItems="center"
          w="100%"
          h="100%"
          bg="primary.700"
          textAlign="center"
          mt={6}
        >
          <Icon name="checkContained" />
          <Text
            as="h2"
            fontWeight="bold"
            fontSize="large"
            color="#97DD45"
            mt={2}
          >
            Verification Code has been sent to the email provided.
          </Text>
          <Text variant="n3" as="span" maxW="552px" mt={4}>
            Check your email. If you have not received this email within a few
            minutes, check your spam folder.
          </Text>
        </Flex>
        <Flex mt={6} justifyContent="flex-end">
          <Button
            rightIcon={<Icon name="ArrowRight" />}
            colorScheme="blue"
            variant="solid"
            onClick={() => setPreview(false)}
          >
            Verify Code
          </Button>
        </Flex>
      </>
    );
  }
  return (
    <>
      <TextInput
        isRequired
        name="mfaCode"
        label="Verification Code"
        placeholder="Enter verification code received by email"
        inputLayoutProps={{ mt: '4' }}
      />
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        w="full"
        gap={6}
        mt={4}
      >
        <Button
          variant="link"
          colorScheme="blue"
          _hover={{ textDecoration: 'none !important' }}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          colorScheme="blue"
          type="submit"
          isLoading={isSubmitting}
          variant="solid"
        >
          Submit
        </Button>
      </Flex>
    </>
  );
};

export default MFAForm;
